module.exports = __webpack_public_path__ + "img/i_h_like_on_big.2baf9a04.svg";